/**
 * @desc 新增供应商sku报价直接发起工作流
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierQuotationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/startWorkflow`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
